import React from 'react'
import NavBar from '../components/Home/NavBar';
import LoginForm from './../components/LoginForm/LoginForm';

const Login = () => {
  return (
    <div className='bg-bgSteps h-screen'>
        <NavBar />
        <LoginForm />
    </div>
  )
}

export default Login